import {
  OFFER_MULTIPLE_OPTIONS_ADDON_DISCOUNT_ENTRY_TYPE,
  OFFER_SINGLE_OPTION_DISCOUNT_ENTRY_TYPE,
  OfferMultipleOptionsAddonDiscountEntryType,
  OfferSingleOptionDiscountEntryType
} from '@ag1/atlas';

const { Value: MultipleOptionsAddonValue, Free } = OFFER_MULTIPLE_OPTIONS_ADDON_DISCOUNT_ENTRY_TYPE;
const { Value: SingleOptionValue, Percentage } = OFFER_SINGLE_OPTION_DISCOUNT_ENTRY_TYPE;

interface DiscountConfig {
  type: OfferMultipleOptionsAddonDiscountEntryType | OfferSingleOptionDiscountEntryType;
  amount: number;
}

export const getRawOfferDiscountedPrice = (rawPrice: number, discountConfig: DiscountConfig) => {
  if (rawPrice === 0) return rawPrice;
  if (
    discountConfig.type === MultipleOptionsAddonValue ||
    discountConfig.type === SingleOptionValue
  )
    return rawPrice - discountConfig.amount;
  if (discountConfig.type === Percentage || discountConfig.type === Free)
    return rawPrice * (1 - discountConfig.amount / 100);

  return rawPrice;
};
